import defineService from "./defineService";
import {toApiAddressFormat} from "./mungeAddress";

const getCurrentTeam = defineService(
  'get',
  'api/v1/team/current/',
  {alternatives: {
    emptyTeam: '-empty' // an "empty" team -- no designs, team members, etc.
  }}
);

export const getCurrentTeamUsers = defineService(
  'get',
  'api/v1/team/current/users/',
  {mainKey: 'results'},
);

export const getTeam = defineService(
  'get',
  'api/v1/team/:id/'
);

const patchTeam = defineService(
  'patch',
  'api/v1/team/:id/'
);

const patchSelf = defineService(
  'patch', 'api/v1/user/'
);

const patchUser = defineService(
  'patch', 'api/v1/user/:id/'
);

const postTeamProductTemplate = defineService(
  'post', 'api/v1/team/producttemplate/'
);

const patchTeamProductTemplate = defineService(
  'patch', 'api/v1/team/producttemplate/:id/'
);

const deleteTeamProductTemplate = defineService(
  'delete', 'api/v1/team/producttemplate/:id/'
);

const postTeamClients = defineService(
  'post', 'api/v1/team/:id/clients/'
);

const postCurrentTeam = defineService(
  'post', 'api/v1/team/current/'
);

export const getTeams = defineService(
  'get', 'api/v1/team/'
);

const getTeamCards = defineService(
  'get', 'api/v1/team/:id/cards/',
  {mainKey: 'results'}
);

const postTeamCard = defineService(
  'post', 'api/v1/team/:id/cards/'
);

const patchTeamCard = defineService(
  'patch', 'api/v1/team/:id/cards/:card'
);

const deleteTeamCard = defineService(
  'delete', 'api/v1/team/:id/cards/:card'
);

const deleteUser = defineService(
  'delete', 'api/v1/user/:id/'
);

const deleteTeamUser = defineService(
  'delete', 'api/v1/team/:id/users/:userid/'
);

export const postTeamUser = defineService(
  'post', 'api/v1/team/:id/users/'
);

export const getUsers = defineService(
  'get', 'api/v1/users/'
);

export const getUser = defineService(
  'get', 'api/v1/users/:id/'
);

/**
 * Return current team info. This ideally includes templates
 * and profile details.
 */
export async function team() {
  return getCurrentTeam();
}

export async function updateTeam(teamId, updates) {
  return patchTeam(teamId, toApiAddressFormat(updates));
}

export async function updateProfile(updates) {
  return patchSelf(updates);
}

export async function updateUserProfile(userid, updates) {
  return patchUser(userid, updates);
}

export async function createProductTeamTemplate(data) {
  return postTeamProductTemplate(data);
}

export async function updateTeamProductTemplate({id, ...updates}) {
  return patchTeamProductTemplate(id, updates);
}

export async function removeTeamProductTemplate(id) {
  return deleteTeamProductTemplate(id);
}

export async function createClient(agencyTeamId, clientTeamInfo) {
  return postTeamClients(agencyTeamId, clientTeamInfo);
}

export async function switchTeam(team) {
  try {
    return postCurrentTeam({team});
  } catch(e) {
    console.log(e);
    if (e.response && e.response.data && e.response.data.details) {
      throw e.response.data.details;
    }
    throw e;
  }
}

export async function savedCards(id) {
  if (id === undefined) throw Error('Missing id');
  return getTeamCards(id);
}

export async function deleteSavedCard(teamId, cardId) {
  return deleteTeamCard(teamId, cardId);
}

export async function addSavedCard(teamId, stripe_token, title, available_to_team=false) {
  try {
    return await postTeamCard(teamId, {stripe_token, title, available_to_team});
  } catch(e) {
    if (e.response && e.response.data && e.response.data.error) {
      throw  e.response.data.error;
    }
    throw e;
  }
}

export async function editSavedCard(teamId, info) {
  try {
    let {id, ...rest} = info;
    return await patchTeamCard(teamId, id, rest);
  } catch(e) {
    if (e.response && e.response.data && e.response.data.error) {
      throw  e.response.data.error;
    }
    throw e;
  }
}

export async function removeUser(id) {
  // This is a dangerous operation! should only be available to super users.
  return deleteUser(id);
}

export async function removeFromTeam(team_id, user_id) {
  // Remove user from team.
  // TODO
  return deleteTeamUser(team_id, user_id);
}



// WEBPACK FOOTER //
// ./src/services/dashboard.js